import { combineLatest, distinctUntilChanged, filter, map, share, switchMap, withLatestFrom } from 'rxjs/operators';
import { Injectable } from '@angular/core'
import { NavigationEnd, NavigationStart, Router } from '@angular/router'

import { Action, select, Store } from '@ngrx/store'
import { Actions, Effect } from '@ngrx/effects'

import { BehaviorSubject, Observable } from 'rxjs'

import * as search from '../../catalog/actions/search.actions'
import * as status from '../actions/status.actions'
import * as pages from '../actions/pages.actions'
import * as menus from '../actions/menus.actions'
import * as orderhistory from '../../orderhistory/actions/order-history.actions'

import * as fromRoot from '../../reducers'
import * as fromBase from '../reducers'
import * as fromCatalog from '../../catalog/reducers'
import * as fromOrderHistory from '../../orderhistory/reducers'

import { PageStatus } from '../models/page-status'

import { getFromUrlTerm } from '../../core/helpers/url-ready'


const HOMEPAGE_TYPE = 'home'
const SEARCH_PAGE_TYPE = 'search'
const ORDERHISTORY_PAGE_TYPE = 'orderhistory'

@Injectable()
export class StatusEffects {
  constructor(
    private actions$: Actions,
    private store: Store<fromBase.State>,
    private router: Router
  ) {}

  @Effect()
  onNavigationStart$: Observable<Action> =
    this.router.events.pipe(filter(ev => ev instanceof NavigationStart))
      .pipe(
        map((event: NavigationStart) => {
          let url = event.url

          if(url.indexOf('?') !== -1)
            url = url.substring(0, url.indexOf('?'))

          return url.substring(1).split('/')
        }),
        distinctUntilChanged(null, (urlSegments) => urlSegments.join('')),
        switchMap(event => [new status.Set(), new menus.Init()]),
        share()
      )

  @Effect()
  onRouterNavigation$: Observable<Action> =
    this.router.events.pipe(filter(ev => ev instanceof NavigationEnd))
      .pipe(
        map(() => new status.Apply())
      )

    @Effect()
    onApplyStatus$: Observable<Action> =
        this.actions$.ofType<status.Apply | status.Reapply>(status.APPLY, status.REAPPLY)
          .pipe(
            withLatestFrom(
              this.store.pipe(select(fromRoot.getRouterInfo)),
              this.store.pipe(select(fromBase.getPages)),
              this.store.pipe(select(fromCatalog.getSearchTerm)),
              (action, router, pages, searchTerm) => ({ router, pages, searchTerm })
            ),
            switchMap((data) => {
              let url = data.router.url
              if(url.indexOf('?') !== -1)
                url = url.substring(0, url.indexOf('?'))

              const urlSegments = url.substring(1).split('/')
              const pagesArr = data.pages
              let searchTerm: string = ''

              let pageStatus: PageStatus
                if (!urlSegments[0]) {
                  pageStatus = {
                    trail: [],
                    current: pagesArr.find(
                      page => page.type === HOMEPAGE_TYPE),
                    loadProducts: false
                  }
                } else if (urlSegments[0].indexOf(SEARCH_PAGE_TYPE) > -1) {
                  pageStatus = {
                    trail: [],
                    current: pagesArr.find(
                      page => page.type === SEARCH_PAGE_TYPE),
                    loadProducts: true
                  }
                  searchTerm = getFromUrlTerm(urlSegments[urlSegments.length - 1])
                } else {
                  const currPage = pagesArr.find(page => page.slug === urlSegments.join('/'))
                  pageStatus = {
                    trail: [],
                    current: currPage,
                    loadProducts: (currPage !== undefined && currPage.type.toLowerCase() === 'catalog')
                  }
                  const segmentsArray = urlSegments

                  let currentSegment

                  for (let i = 0; i < segmentsArray.length; i++) {
                    let entry = null
                    if (i === 0) {
                      currentSegment = segmentsArray[i]
                      entry = pagesArr.find(page => page.slug === currentSegment)
                      pageStatus.trail.push(entry)
                    } else {
                      currentSegment += `/${segmentsArray[i]}`
                      entry = pagesArr.find(page => page.slug === currentSegment)
                      pageStatus.trail.push(entry)
                    }
                  }
                }
                let actionsArr: any[] = [
                  new status.ApplySuccess(pageStatus),
                  new menus.Navigate(pageStatus && pageStatus.current && pageStatus.current.code)
                ]

                if (searchTerm) {
                  actionsArr.unshift(new search.SetSearchTerm(searchTerm))
                }

                if (!searchTerm && data.searchTerm) {
                  actionsArr.unshift(new search.ClearSearchTerm())
                }

              return actionsArr
            })
          )
}
